export const ERR_REQUIRED = "This value is required.";
export const ERR_INVALID_NAME = "Please enter a valid name.";
export const ERR_INVALID_EMAIL = "Please enter a valid email address";
export const ERR_INVALID_PHONE_NUMBER = "Please enter a valid phone number";
export const ERR_INVALID_DATE = "Please enter a valid date";
export const ERR_INVALID_URL = "Please enter a valid url";
export const ERR_INVALID_BOOLEAN = "Please select true or false";
export const ERR_INVALID_NUMBER = "Please enter a valid number";
export const ERR_EXCEEDS_MAX_CHARACTERS = "This value exceeds the character limit";

export const NOTES_MAX_LENGTH = 64;

export interface ValidationResponse {
	status: number;
	title?: string;
	headers?: Record<string, string | null>;
	error?: unknown;
}
